import { render, staticRenderFns } from "./dieBodyUS.vue?vue&type=template&id=1ceba8de&scoped=true"
import script from "./dieBodyUS.vue?vue&type=script&lang=js"
export * from "./dieBodyUS.vue?vue&type=script&lang=js"
import style0 from "./dieBodyUS.vue?vue&type=style&index=0&id=1ceba8de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ceba8de",
  null
  
)

export default component.exports